export default function sanitizeBranchName(branchName: string): string {
  return branchName.replaceAll(".", "_").replaceAll("/", "_");
}
